import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import { integracaoService } from '@/services/integracao.service'
import type { Integracao, UUID } from '@/types/database'

export function useIntegracoes() {
    return useQuery({
        queryKey: ['integracoes'],
        queryFn: integracaoService.list,
    })
}

export function useIntegracao(id: UUID | undefined) {
    return useQuery({
        queryKey: ['integracoes', id],
        queryFn: () => integracaoService.get(id!),
        enabled: !!id,
    })
}

export function useCreateIntegracao() {
    const qc = useQueryClient()
    return useMutation({
        mutationFn: integracaoService.create,
        onSuccess: () => qc.invalidateQueries({ queryKey: ['integracoes'] }),
    })
}

export function useUpdateIntegracao() {
    const qc = useQueryClient()
    return useMutation({
        mutationFn: ({ id, ...data }: Partial<Integracao> & { id: UUID }) => integracaoService.update(id, data),
        onSuccess: () => qc.invalidateQueries({ queryKey: ['integracoes'] }),
    })
}

export function useDeleteIntegracao() {
    const qc = useQueryClient()
    return useMutation({
        mutationFn: integracaoService.remove,
        onSuccess: () => qc.invalidateQueries({ queryKey: ['integracoes'] }),
    })
}

export function useTestIntegracao() {
    return useMutation({
        mutationFn: ({ id, payload }: { id: UUID, payload: any }) => integracaoService.test(id, payload),
    })
}
